import { CSSProperties, useCallback, useEffect, useState } from 'react';
import { Avatar, Dropdown, Modal, Popover, Stack, Whisper } from 'rsuite';
import ArrowDownIcon from '@rsuite/icons/ArrowDown';
import { UserMenu } from './UserMenu';
import { OUTreeContent } from './OUTree';

interface IProps {
  account: Record<string, any>;
  loginSaml: Record<string, any>;
  avatarUrl?: string;
  onClose?: () => void;
  className?: string;
  commonData?: Record<string, any>;
  isNewPortal?: boolean;
}

export const UserProfile = ({
  account,
  loginSaml,
  avatarUrl,
  onClose,
  className,
  commonData,
  isNewPortal
}: IProps) => {
  const [open, setOpen] = useState(false);
  const [displayName, setDisplayName] = useState(
    account?.user_name || account?.account_email
  );
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleSelect = (eventKey: string | number | undefined) => {
    if (onClose) {
      onClose();
    }
  };

  const stylePanel: CSSProperties = {
    maxWidth: '300px',
    minWidth: '256px',
    minHeight: '172px',
    padding: '25px 25px'
  };

  useEffect(() => {
    if (account?.user_display_info?.length) {
      const name = account.user_display_info.find(
        (o: Record<string, any>) =>
          o.name === 'Username' ||
          o.name === 'IAM Username' ||
          o.name.includes('Username')
      );
      const federatedLogin = account.user_display_info.find(
        (o: Record<string, any>) => o.name === 'Federated Login'
      );
      setDisplayName(
        [federatedLogin?.value, name?.value].filter((s) => s).join(' - ')
      );
    } else if (loginSaml?.displayName) {
      setDisplayName(loginSaml.displayName);
    }
  }, [account?.user_display_info, loginSaml]);

  const renderUserProfile = useCallback(
    (props: any, ref: any) => {
      const { className, left, top, onClose } = props;

      return (
        <Popover ref={ref} className={className} full>
          <Dropdown.Menu onSelect={handleSelect}>
            <div>
              <Stack>
                {account?.user_display_info?.length && (
                  <Stack.Item
                    style={{
                      ...stylePanel,
                      borderRight: '1px solid #dee2eb'
                    }}
                  >
                    {account.user_display_info.map((obj: any, idx: number) => (
                      <div
                        key={idx}
                        style={{
                          borderBottom:
                            idx === account.user_display_info.length - 1
                              ? 'none'
                              : '1px dashed #dee2eb',
                          padding: '8px 0 11px'
                        }}
                      >
                        <span
                          style={{
                            display: 'block',
                            color: '#a0a9b8',
                            fontSize: '9px',
                            fontWeight: 400,
                            letterSpacing: '.065em',
                            textTransform: 'uppercase'
                          }}
                        >
                          {obj?.name}
                        </span>

                        <span
                          style={{
                            fontSize: '13px',
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word'
                          }}
                        >
                          {obj?.value}
                        </span>
                      </div>
                    ))}
                  </Stack.Item>
                )}

                <UserMenu
                  onClose={onClose}
                  handleOpen={handleOpen}
                  account={account}
                  commonData={commonData}
                  stylePanel={stylePanel}
                />
              </Stack>
            </div>
          </Dropdown.Menu>
        </Popover>
      );
    },
    [account, commonData]
  );

  return (
    <>
      <Whisper
        placement="bottomEnd"
        trigger="click"
        speaker={renderUserProfile}
      >
        <Stack spacing={5} alignItems="center" style={{ cursor: 'pointer' }}>
          {avatarUrl && (
            <Avatar
              size="xs"
              circle
              src={avatarUrl}
              alt="@simonguo"
              style={{ position: 'relative', top: '3px' }}
            />
          )}
          <span style={{ whiteSpace: 'nowrap' }}>{displayName}</span>
          <ArrowDownIcon />
        </Stack>
      </Whisper>
      <Modal open={open} onClose={handleClose} size={'md'}>
        <Modal.Header>
          <Modal.Title>Make a Selection to Proceed</Modal.Title>
        </Modal.Header>
        <Modal.Body className="fsoc-popup">
          <OUTreeContent
            setOpen={setOpen}
            ignoreGroup={true}
            isNewPortal={isNewPortal}
          ></OUTreeContent>
        </Modal.Body>
      </Modal>
    </>
  );
};
